import React from "react";

const Footer = () => {
  return (
    <footer className="main-footer text-right">
      © 2000-present. Gracenote, A Nielsen Company. All rights reserved.
    </footer>
  );
};

export default Footer;
